<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
    >Edição Regra de Alerta</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div [formGroup]="form" class="mt-8 mb-0">
    <div>
      <div class="flex justify-start gap-4 items-center">
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Valor mínimo</mat-label>
          <input type="number" matInput formControlName="initial" />
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Valor máximo</mat-label>
          <input type="number" matInput formControlName="final" />
        </mat-form-field>
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Mensagem</mat-label>
          <mat-select formControlName="message">
            @for (type of listMunicipios; track type) {
              <mat-option [value]="type.id">{{ type.texto }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex justify-end mt-3">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!form.valid || loading"
        (click)="editLocation()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Editar
        }
      </button>
    </div>
  </div>
</mat-card>
